import { css } from 'styled-components';
import { map } from '../../breakpoint';
import { m, mx, my, mt, mb, ml, mr, mbs, mie, mbe, mis, mbl, mi } from '../../spacing';
export const margins = () => css`
  ${_ref => {
  let {
    margin
  } = _ref;
  return map(margin, val => val !== undefined && css`
          ${m(val)};
        `);
}};

  ${(_ref2 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    marginHorizontal
  } = _ref2;
  return map(marginHorizontal, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
  ) => val !== undefined && css`
          ${mx(val)};
        `);
}};

  ${(_ref3 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    marginVertical
  } = _ref3;
  return map(marginVertical, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
  ) => val !== undefined && css`
          ${my(val)};
        `);
}};

  ${(_ref4 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    marginTop
  } = _ref4;
  return map(marginTop, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
  ) => val !== undefined && css`
          ${mt(val)};
        `);
}};

  ${(_ref5 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    marginBottom
  } = _ref5;
  return map(marginBottom, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
  ) => val !== undefined && css`
          ${mb(val)};
        `);
}};

  ${(_ref6 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    marginLeft
  } = _ref6;
  return map(marginLeft, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
  ) => val !== undefined && css`
          ${ml(val)};
        `);
}};

  ${(_ref7 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    marginRight
  } = _ref7;
  return map(marginRight, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
  ) => val !== undefined && css`
          ${mr(val)};
        `);
}};

  ${(_ref8 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    marginBlockStart
  } = _ref8;
  return map(marginBlockStart, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
  ) => val !== undefined && css`
          ${mbs(val)};
        `);
}};

  ${(_ref9 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    marginInlineEnd
  } = _ref9;
  return map(marginInlineEnd, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
  ) => val !== undefined && css`
          ${mie(val)};
        `);
}};

  ${(_ref10 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    marginBlockEnd
  } = _ref10;
  return map(marginBlockEnd, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
  ) => val !== undefined && css`
          ${mbe(val)};
        `);
}};

  ${(_ref11 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    marginInlineStart
  } = _ref11;
  return map(marginInlineStart, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
  ) => val !== undefined && css`
          ${mis(val)};
        `);
}};

  ${(_ref12 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    marginBlock
  } = _ref12;
  return map(marginBlock, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
  ) => val !== undefined && css`
          ${mbl(val)};
        `);
}};

  ${(_ref13 // eslint-disable-line  @typescript-eslint/no-explicit-any
) => {
  let {
    marginInline
  } = _ref13;
  return map(marginInline, (val // eslint-disable-line  @typescript-eslint/no-explicit-any
  ) => val !== undefined && css`
          ${mi(val)};
        `);
}};
`;